import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Template } from '../interfaces/template';
import { CreateTemplateRequest } from './../models/create-template-request';

@Injectable({ providedIn: 'root' })
export class TemplateService {
  private url = '/api/template/jsontemplates';

  constructor(private httpClient: HttpClient) { }

  public getTemplates(): Observable<Array<Template>> {
    return this.httpClient.get<Array<Template>>(this.url);
  }

  public getTemplate(templateId: string): Observable<any> {
    return this.httpClient.get<Template>(`${this.url}/${templateId}`);
  }

  public createTemplate(createTemplateRequest: CreateTemplateRequest): Observable<any> {
    return this.httpClient.post(this.url, createTemplateRequest);
  }

  public updateTemplate(createTemplateRequest: CreateTemplateRequest): Observable<any> {
    return this.httpClient.put(this.url, createTemplateRequest);
  }

  public deleteTemplate(templateId: string): Observable<any> {
    return this.httpClient.delete(`${this.url}/${templateId}`);
  }
}
